import { render } from "./GenericTable.vue?vue&type=template&id=4fe1b5dc&ts=true"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"

import "./GenericTable.vue?vue&type=style&index=0&id=4fe1b5dc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__